module.exports = __webpack_public_path__ + "static/media/drinks-admin.cadca286.svg";